export const firebaseConfig = {
  apiKey: 'AIzaSyC23P94VmOXDE0GpKGMRRRkr2zkBaiUZc0',
  authDomain: 'agamasac-gas-station-prod.firebaseapp.com',
  projectId: 'agamasac-gas-station-prod',
  storageBucket: 'agamasac-gas-station-prod.appspot.com',
  messagingSenderId: '305913983991',
  appId: '1:305913983991:web:23b758b85e470a413334f2',
  measurementId: 'G-VEH6DS5SGQ',
}
